import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack, TextareaAutosize } from '@mui/material'
import Multiselect from './components/Multiselect'
import { Description } from '@mui/icons-material'
import Editor from 'components/editor'


const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description,setDescription] = useState('')

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }


  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }




  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);

    const payload = {
      title: e.target.title.value,
      description,
      transcript: e.target.transcript.value,
      video: e.target.video.value,


    };

    console.log(payload, "payload");



    const { response } = await AppService.exchangepodcast.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Title</MDTypography>
              <MDInput label="Title" name="title" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Transcript</MDTypography>
              <TextareaAutosize
                className="form-control"
                style={{ minHeight: '70px' }}
                placeholder="transcript"
                name="transcript"
              />
              {/* <MDInput label="transcript" name="transcript" fullWidth /> */}
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Video</MDTypography>
              <MDInput label="video" name="video" fullWidth />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
